import React from 'react';
import { Outlet } from 'react-router-dom';
import StorefrontHeader from './StorefrontHeader';
import StorefrontFooter from './StorefrontFooter';

// Layout aplicado a rotas públicas QUANDO o tenant é resolvido (host de loja
// ou ?tenantId=). Substitui o Header/Footer institucional do Reviter pelos
// equivalentes da loja (com busca, categorias, etc).
const StorefrontLayout = () => (
  <div className="min-h-screen flex flex-col bg-app-bg">
    <StorefrontHeader />
    <main className="flex-1">
      <Outlet />
    </main>
    <StorefrontFooter />
  </div>
);

export default StorefrontLayout;
